// extracted by mini-css-extract-plugin
export default {"p":"_5ebee5182c _9c0d62d2e4 badfca1b3b","clr":"c84c31c5f7","dls":"_54a12862ce"};